import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//--
import { StrReplacePipe } from './str-replace.pipe';
import { MomentPipe } from './moment.pipe';
import {FirstLetterUpperPipe} from './first-letter-upper.pipe';
import { UnSortJSONPipe } from './unsortJSON.pipe';
import { toTrustedPipe } from "./toTrusted.pipe";
import { CapitalizePipe } from './capitalize.pipe';
import { CurrencyPipe } from './currency.pipe';
import { DatePipe } from './date.pipe';
import { TimePipe } from './time.pipe';
import {EscapeHtmlPipe } from  './keep-html.pipe';
import {KeysPipe} from "@app/pipes/keys.pipe";
import { LongDatePipe } from './long_date.pipe';
import { CompressCommasPipe } from './compress-commas.pipe';
import { TimelineDatePipe, TimeStringFromSeconds } from './timeline-date.pipe';
import {truncate} from "@app/pipes/truncate.pipe";
import {FilterFieldValuePipe} from "@app/pipes/filter-field-value.pipe";
import { SanitizehtmlPipe } from './sanitizehtml.pipe';
import { ShortDatePipe } from './short_date.pipe';
import { CallbackPipe } from './callback.pipe';
import {SafeStylePipe} from "@app/pipes/safe-style.pipe";
import {KeepOriginalOrderPipe} from "@app/pipes/keep-original-order.pipe";
import {PhoneDisplayFormatPipe} from "@app/pipes/phone-display-format.pipe";

@NgModule({
  declarations: [
    StrReplacePipe,
    MomentPipe,
    FirstLetterUpperPipe,
    UnSortJSONPipe,
    toTrustedPipe,
    CapitalizePipe,
    CurrencyPipe,
    DatePipe,
    TimePipe,
    EscapeHtmlPipe,
    KeysPipe,
    LongDatePipe,
    ShortDatePipe,
    CompressCommasPipe,
    TimelineDatePipe,
      TimeStringFromSeconds,
      truncate,
      FilterFieldValuePipe,
      SanitizehtmlPipe,
      CallbackPipe,
      SafeStylePipe,
      KeepOriginalOrderPipe,
      PhoneDisplayFormatPipe
  ],
  imports: [
    CommonModule
  ],
    exports: [
        StrReplacePipe,
        MomentPipe,
        FirstLetterUpperPipe,
        UnSortJSONPipe,
        toTrustedPipe,
        CapitalizePipe,
        CurrencyPipe,
        DatePipe,
        TimePipe,
        EscapeHtmlPipe,
        KeysPipe,
        LongDatePipe,
        ShortDatePipe,
        CompressCommasPipe,
        TimelineDatePipe,
        TimeStringFromSeconds,
        truncate,
        FilterFieldValuePipe,
        SanitizehtmlPipe,
        CallbackPipe,
        SafeStylePipe,
        KeepOriginalOrderPipe,
        PhoneDisplayFormatPipe
    ]
})
export class PipesModule { }
